const localization = {
  en: {
    component: 'Result',
    componentResult: 'Results',
    standardRange: 'Normal Range',
    value: 'Value',
    general: 'General Information',
    resulted: 'Resulted',
    resultStatus: 'Result Status',
    noResults: 'No results',
    date: 'Date'
  },
  es: {
    component: 'Resultado',
    componentResult: 'Resultados',
    standardRange: 'Rango normal',
    value: 'VALOR',
    general: 'Información general',
    resulted: 'Resultado',
    resultStatus: 'Estatus de los resultados',
    noResults: 'Sin resultados',
    date: 'Fecha'
  },
  keyMapping: {
    date: 'UFD_Date_Text',
    standardRange: 'UFD_Normal_Range_Text',
    component: '',
    componentResult: '',
    value: '',
    general: '',
    resulted: '',
    resultStatus: '',
    noResults: ''
  }
}

export default localization
